import { TemplateFormError } from '../interfaces/template-form';

export function throwTemplateFormError(message: string) {
  return Promise.reject(new TemplateFormError(message));
}
